import { render, staticRenderFns } from "./issueCard.vue?vue&type=template&id=6986e934&scoped=true&"
import script from "./issueCard.vue?vue&type=script&lang=js&"
export * from "./issueCard.vue?vue&type=script&lang=js&"
import style0 from "./issueCard.vue?vue&type=style&index=0&id=6986e934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986e934",
  null
  
)

export default component.exports